module.exports = __webpack_public_path__ + "static/media/23-02-21_politicas_de_privacidad_sitio_web.1d01d2e9.docx";